import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import ListingBadge, { BADGE_MODE } from './base';
import { getBrokerAgent, isREO } from './utils';
export default class AgentInformationBadge extends ListingBadge {
    static title = 'Contact Agent Info';
    static titleIcon = 'user-tie';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            _.isPlainObject(getBrokerAgent(listing)) &&
            isREO(listing));
    }
    get content() {
        return (_jsxs(_Fragment, { children: [_jsx("a", { onClick: e => this.emitEvent('contact_agent', e), children: "Get in touch" }), ' ', "with the listing agent for this property"] }));
    }
}
//# sourceMappingURL=agentInformation.js.map